export default "__VITE_ASSET__66469dbe__"